import { faCreditCard, faFileExport } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DatePicker, Descriptions, Modal, Space } from "antd"
import VSpace from "../../common/VSpace"
import { centsToDollarsDisplay } from "../../displayFormatters"
import LabeledSwitch from "../../common/LabeledSwitch"
import dayjs from "dayjs"
import { useEffect, useState } from "react"
import { ExportInvoiceData, Invoice } from "../../../domain/invoicing/invoice"
import { useExportInvoiceMutation } from "../../../domain/invoicing/invoicingQueries"

type Props = {
  isOpen: boolean
  onClose: () => void
  invoice: Invoice
  onExported: (qboInvoiceUrl: string) => void
}

const ExportInvoiceModal = ({isOpen, onClose, invoice, onExported}: Props) => {
  const dataFromInvoice = (): ExportInvoiceData => ({
    invoiceId: invoice.id,
    dueOn: invoice.dueOn,
    enableCreditCardPayments: invoice.enableCreditCardPayments,
    enableAchPayments: invoice.enableAchPayments
  })

  const exportInvoice = useExportInvoiceMutation(onExported)

  const [data, setData] = useState<ExportInvoiceData>(dataFromInvoice())
  useEffect(() => setData(dataFromInvoice()), [invoice, isOpen])

  return <Modal
    open={isOpen}
    okText="Export to QuickBooks"
    onOk={() => exportInvoice.mutate(data)}
    okButtonProps={{ loading: exportInvoice.isLoading }}
    onCancel={() => {
      if (exportInvoice.isLoading) {
        return
      }
      onClose()
    }}
    cancelButtonProps={{ disabled: exportInvoice.isLoading }}
    title={<Space><FontAwesomeIcon icon={faFileExport}/> Export Invoice to QuickBooks Online</Space>}
  >
    <Descriptions column={1} bordered>
      <Descriptions.Item label="Amount">
        {centsToDollarsDisplay(invoice.amount)}
      </Descriptions.Item>
      <Descriptions.Item label="Due on">
        <DatePicker
          value={dayjs(data.dueOn)}
          onChange={x => setData({...data, dueOn: x?.toISOString() ?? dayjs().toISOString()})}
          disabled={exportInvoice.isLoading}
        />
      </Descriptions.Item>
      <Descriptions.Item label="Payment Options">
        <VSpace>
          <LabeledSwitch
            value={data.enableCreditCardPayments}
            label={<span>Enable Card Payments <CardPaymentIcons /></span>}
            onChange={x => setData({...data, enableCreditCardPayments: x})}
            disabled={exportInvoice.isLoading}
          />
          <LabeledSwitch
            value={data.enableAchPayments}
            label="Enable Bank Transfers (ACH)"
            onChange={x => setData({...data, enableAchPayments: x})}
            disabled={exportInvoice.isLoading}
          />
        </VSpace>
      </Descriptions.Item>
    </Descriptions>
  </Modal>
}

export default ExportInvoiceModal

const CardPaymentIcons = () => {
  return <>
    <FontAwesomeIcon icon={faCreditCard} />
  </>
}